import { DocDetails } from '../models';

let reportTypes = {
    RAW: 'json',
    RPT: 'pdf',
    IMG: 'png',
};

/*
Implements utility functions to be used across project
*/

/*eslint no-useless-escape:"off",eqeqeq: "off"*/

export function IsObjectHaveKeys(obj) {
    return obj && typeof obj == 'object' && Object.keys(obj).length;
}

export function capitalizeSentence(sentence) {
    const words = sentence.split(' ');

    return words
        .map((word) => {
            return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
}

// export function capitalizeStrings(str) {
//     // Split the string at all space characters
//     return str.trim().split(' ')
//         // get rid of any extra spaces using trim
//         .map(a => a.trim())
//         // Convert first char to upper case for each word
//         .map(a => a[0].toUpperCase() + a.substring(1).toLowerCase())
//         // Join all the strings back together
//         .join(" ")
// }

export function capitalizeStrings(str) {
    return str;
}

/**
 * Load the file from the particular path
 *
 * @param {*} report_link
 * @returns
 */
export async function loadPDF({
    report_link,
    config = {
        requireLinuxPath: false,
        replaceBranch: false,
    },
    url,
    type = 'RPT',
}) {
    let filePath = report_link;

    // We have 4 cases two handle here
    // Case 1 - Application hosted on linux and require a replacement for url - No Usecase right now
    // Case 2 - Application hosted on linux and does not require a replacement for url - For local site - hyderabad
    // Case 3 - Application hosted on windows an require a replacement of url  - For Remote Usage - delhi / mumbai / hyderabad
    // Case 4 - Application hosted on windows and do not require a replace of url - For Local Site Usage - Mumbai

    // For the linux vm we require file structure to be changed
    filePath = replaceFileName(report_link, config.requireLinuxPath, config.replaceBranch);

    const uncompressedArray = await DocDetails.loadFile(config, filePath.trim(), reportTypes[type], {});

    var fileImage = new Blob([uncompressedArray], { type: `application/${reportTypes[type]}` });

    return URL.createObjectURL(fileImage);
}

/**
 * Replace the filename with BLR for any other branch
 * This is a custom implementation for Nura
 *
 * @param {*} fileName
 * @returns
 *
 * @author Ashique Mohammed
 */
function replaceFileName(fileName, requireLinuxPath, replaceFileName) {
    if (replaceFileName) {
        const wordsToReplace = ['DEL', 'BOM', 'HYD', 'CCJ'];

        // // The path has to be changed to bangalore
        const replacementString = 'BLR';

        // To replace if its either of the strings and case insensitive
        const regex = new RegExp(wordsToReplace.join('|'), 'i');

        fileName = fileName.replace(regex, replacementString);
    } else {
        fileName = fileName;
    }

    // We need to get the raw path and replace it for use in linux
    // For normal we dont want that .
    return requireLinuxPath ? String.raw`${fileName}`.replace(/\\/g, '/') : fileName;
}

// Get Words first letters
export function getInitials(name) {
    if (!name) return '';

    const titlesToIgnore = ['mr', 'mrs', 'ms', 'miss', 'dr', 'prof', 'sir'];

    const words = name
        .trim()
        .split(/\s+/)
        .filter((word) => !titlesToIgnore.includes(word.toLowerCase().replace(/\./g, '')));

    return words.length > 0 ? words[0][0].toUpperCase() : '';
}

/**
 * Safely parses a JSON string.
 *
 * @param {string|Object} value - JSON string or object to parse.
 * @returns {Object|null} The parsed JSON object or null if parsing fails.
 *
 */
export const parseJSON = (value) => {
    try {
        return typeof value === 'string' ? JSON.parse(value) : value;
    } catch {
        return null;
    }
};

/**
 * Transforms a response array into a normalized list of file objects.
 **/
export function transformToFiles(response, requireLinuxPath, replaceBranch) {
    // Use reduce to build up a new array of file objects
    return response.reduce((acc, item) => {
        // Skip this item if it does not have a report_path
        if (!item?.report_path) return acc;

        // Destructure required fields from the item
        const { modality_code, report_path, modality_description, modality_serial_no } = item;

        let filePath = replaceFileName(report_path, requireLinuxPath, replaceBranch);

        // Push a normalized file object into the accumulator
        acc.push({
            path: filePath.trim(),
            mod_code: modality_code,
            mod_slno: modality_serial_no,
            mod_desc: modality_description,
        });

        // Return accumulator for next iteration
        return acc;
    }, []);
}

// function that converts "Female" → "F" and "Male" → "M".
export function getGenderShort(genderStr) {
    if (!genderStr) return null;
    const g = genderStr.trim().toLowerCase();
    if (g === 'female') return 'F';
    if (g === 'male') return 'M';
    return null;
}

// Remove prefixes like Mr. / Ms. / Mrs. / Dr. from a name string
export const cleanName = (nameStr) => nameStr.replace(/^(Mr|Ms|Mrs|Dr)\.\s*/i, '').trim();

// NormalizeParams
export function normalizeParam(value) {
    if (!value) return '';
    try {
        return decodeURIComponent(value.replace(/\+/g, ' ')).trim();
    } catch {
        // fallback in case of malformed URI
        return value.replace(/\+/g, ' ').trim();
    }
}

/*
 * The function `getNormaliseGender` normalizes gender values to 'Male' or 'Female'.
 * @param gender - The `getNormaliseGender` function takes a gender parameter as input and normalizes
 * it to either 'Male', 'Female', or null based on the input value. If the input is 'M' or 'Male', it
 * returns 'Male'. If the input is 'F' or 'Female
 * @returns The function `getNormaliseGender` returns the normalized gender value based on the input
 * provided. If the input is 'M' or 'Male', it returns 'Male'. If the input is 'F' or 'Female', it
 * returns 'Female'. Otherwise, it returns `null`.
 */
export function getNormaliseGender(gender) {
    if (gender === 'M' || gender === 'Male') return 'Male';
    if (gender === 'F' || gender === 'Female') return 'Female';
    return null;
}
